<template>
    <div style="background: #fff;height:100%">
        <Headers :title="title" />
        <div class="title-wrap">
            <div class="title-wrap-left">
                <img :src="logo || unlogo" alt="">
            </div>
            <div class="title-wrap-right">
                <div class="company-name">{{language == 'zh'? companyName : companyEnName}}</div>
                <div class="company-place">
                    <img class="icon" src="~statics/mobileShouye/location.png" alt="">
                    <div class="address">{{address}}</div>
                </div>
                <div v-if="this.store == 0" class="store" @click.stop="handleCollect()">
                    <img class="store-icon" src="~statics/mobileShouye/unstore.png" alt="">
                    <span class="store-name">{{$t('detail').collect}}</span>
                </div>
                <div v-else class="store" @click.stop="handleCollect()">
                    <img class="store-icon"  src="~statics/mobileShouye/store.png" alt="">
                    <span class="store-name">{{$t('detail').uncollect}}</span>
                </div>
            </div>
        </div>
        <div class="info-wrap">
            <div class="info-title">
                <div class="line"></div>
                <div class="title-name">
                    {{$t("about").h2}}
                </div>
            </div>
            <div class="info">
                <div class="info-content">
                    <span class="info-content-title">{{$t("about").msg1}}:</span>
                    <span class="info-content-desc">{{ register_capital}}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t("about").msg2}}:</span>
                    <span class="info-content-desc">{{ employee_num | employee_nums }}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t("about").msg3}}:</span>
                    <span class="info-content-desc">{{ website }}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t("about").msg4}}:</span>
                    <span class="info-content-desc">{{language == 'zh'? main_products : en_main_products}}</span>
                </div>
                <div class="info-content">
                    <span class="info-content-title">{{$t("about").msg5}}:</span>
                    <span class="info-content-desc">{{language == 'zh'? sale_scope : en_sale_scope }}</span>
                </div>
            </div>
        </div>
        <div class="info-wrap-desc">
            <div class="info-title">
                <div class="line"></div>
                <div class="title-name">
                    公司简介
                </div>
            </div>
            <div class="info">
                <div class="info-desc">{{language == 'zh'? text : entext}}</div>
            </div>
        </div>
    </div>
</template>

<script>
import Headers from "../mobileExhibition/components/Headers";
import Footers from "../mobileExhibition/components/Footers";
import { mapState } from "vuex";
import api from "@/api";

export default {
    
    data(){
        return{
            unlogo: require("statics/no-logo-new.png"),
            // title: "展台", 
            companyName: "", //企业中文名称
            companyEnName: "", //英文名称
            logo: "", //logo
            text: "", //基本信息
            entext: "",
            address: "" ,//地址
            register_capital: "", //注册资本
            employee_num: "", //企业规模
            website: "", //网址
            main_products: "", //主营产品
            en_main_products: "",
            sale_scope: "", //销售范围
            en_sale_scope: "",
            store: '',
            company_id: null,
            exhibition_id: null,
            instance_id: null
        }
    },
    computed: {
        language(){
            return localStorage.getItem('language') || 'zh'
        },
        title(){
            return this.language == 'zh' ? '展台介绍' : 'The booth is introduced'
        },
        ...mapState(["userInfo","language"]),
    },
    created() {
        this.exhibition_id = this.$route.query.exhibition_id;
        this.company_id = this.$route.query.company_id
        this.instance_id = this.$route.query.instance_id
        this.companyName = "";
        this.logo = "";
        this.text = "";
        this.register_capital = "";
        this.employee_num = "";
        this.website = "";
        this.main_products = "";
        this.sale_scope = "";
        this.address = ""
        this.getExhibitor();
    },
    mounted(){
        // alert(this.userInfo.id);
    },
    methods: {
        getExhibitor() {
            api.getExhibitionDetali({
                id: this.company_id,
                params: {
                    exhibition_id: this.exhibition_id
                }
            }).then((res) => {
                // console.log(res.info)
                this.companyName = res.info.company.name;
                this.companyEnName = res.info.company.locales.en.name
                // this.logo = res.info.profile.cn.images.length ? res.info.profile.cn.images[0].url : "";
                this.logo = res.info.profile.cn.images[0].url
                this.text = res.info.profile.cn.info;
                this.entext = res.info.profile.en.info;
                this.address = res.info.company.address
                this.main_products = res.info.profile.cn.main_products;
                this.en_main_products = res.info.profile.en.main_products;
                this.sale_scope = res.info.profile.cn.sale_scope;
                this.en_sale_scope = res.info.profile.en.sale_scope;
                this.register_capital = res.info.company.register_capital;
                this.employee_num = res.info.company.employee_num;
                this.website = res.info.company.website;
                this.store = res.info.is_store
                console.log(res.info);
            });
        },
        handleCollect(){
            if(!this.userInfo.id) {
                this.$notify({ type: 'danger',background: '#3a3c3f', message: '请先登录后收藏' });
                return
            }else{
                if(this.store == 0){
                    this.collect()
                    return
                }else{
                    this.cancelCollect()
                    return
                }
            }
        },
        collect() {
            api.isCollectExhibitors({
                exhibition_id: this.exhibition_id,
                company_id: this.company_id 
            }).then((res) => {
                // console.log(res);
                if (res.res == 1) {
                    this.store = 1;
                    this.$notify({ type: 'success', message: '收藏成功' });
                }
            });
        },
        cancelCollect() {
            api.noCollectExhibitors({
                exhibition_id: this.exhibition_id,
                company_id: this.company_id
            }).then((res) => {
                // console.log(res);
                if (res.res == 1) {
                    this.store = 0;
                    this.$notify("取消收藏");
                }
            });
        },
    },
    components: {
        Footers,
        Headers
    },
    filters: {
        employee_nums(val) {
            let str = "";
            switch (val) {
                case 1:
                    str = "0~49人";
                    break;
                case 2:
                    str = "50~199人";
                    break;
                case 3:
                    str = "200~999人";
                    break;
                case 4:
                    str = "1000~9999人";
                    break;
                case 5:
                    str = "10000人以上";
                    break;
                default:
                    str = "未知";
            }
            return str;
        }
    }
}
</script>

<style lang="scss" scoped>
/deep/ .van-notice-bar__content{
    line-height: .32rem;
    color: #ffffff;
    opacity: 1;
    font-size: 12px
}
/deep/ .van-notice-bar__left-icon{
    color: #fff;
}
/deep/ .van-notice-bar__right-icon{
    color: #fff;
}
/deep/ .van-nav-bar__title{
    color: #fff;
}
/deep/ .van-hairline--bottom{
    background: #194b96;
}
/deep/ .van-icon-search{
    color: #fff;
}
.title-wrap{
    width: 7.2rem;
    height: 2.52rem;
    border-bottom: 1px solid #f1f1f8;
    margin: .38rem 0 0 .28rem;
    display: flex;
    .title-wrap-left{
        width: 3.4rem;
        height: 2.14rem;
        margin-right: .22rem;
        border: 1px solid #e1e1ed;
        border-radius: 7px;
        display: flex;
        justify-content: center;
        align-items: center;
        img{
            max-width: 100%;
            max-height: 2.14rem;
            object-fit: contain;
            padding: .08rem;
        }
    }
    .title-wrap-right{
        .company-name{
            width: 3.3rem;
            font-size: 18px;
            color: #333333;
            line-height: .48rem;
        }
        .company-place{
            display: flex;
            margin: .26rem 0 .24rem 0;
            .icon{
                width: .24rem;
                height: .28rem;
                margin-right: .12rem;
            }
            .address{
                color: #999999;
                line-height: .32rem;
                font-size: 12px;
            }
        }
        .store{
            display: flex;
            .store-icon{
                width: .24rem;
                height: .24rem;
                margin-right: .12rem;
            }
            .store-name{
                line-height: .3rem;
                color: #999;
                font-size: 12px;
            }
        }
    }
}
.info-wrap{
    width: 6.9rem;
    // height: 4.22rem;
    border-bottom: 1px solid #f1f1f8;
    // background: red;
    margin: .4rem 0 0 .3rem;
    padding-bottom: .4rem;
    .info-title{
        display: flex;
        .line{
            width: .06rem;
            height: .36rem;
            background: #194b96;
            margin-right: .12rem;
        }
        .title-name{
            color: #333333;
            line-height: .42rem;
            font-size: 16px;
        }
    }
    .info{
        margin-top: .2rem;
        width: 6.9rem;
        .info-content{
            margin-bottom: .1rem;
            width: 6.9rem;
            display: flex;
            justify-content: center;
            .info-content-title{
                width: 2.3rem;
                margin-right: .3rem;
                font-size: 14px;
                color: #666666;
                line-height: .46rem;
            }
            .info-content-desc{
                width: 4.64rem;
                line-height: .46rem;
                color: #333;
                font-size: 14px;
            }
        }
        
    }
}
.info-wrap-desc{
    width: 6.9rem;
    // height: 4.22rem;
    border-bottom: 1px solid #f1f1f8;
    // background: red;
    margin: .4rem 0 0 .3rem;
    padding-bottom: .4rem;
    .info-title{
        display: flex;
        .line{
            width: .06rem;
            height: .36rem;
            background: #194b96;
            margin-right: .12rem;
        }
        .title-name{
            color: #333333;
            line-height: .42rem;
            font-size: 16px;
        }
    }
    .info{
        .info-desc{
            margin-top: .2rem;
            font-size: 14px;
            color: #666666;
            line-height: .46rem;
        }
    }
    
}
</style>


// WEBPACK FOOTER //
// src/views/mobile/mobileAboutCompany/index.vue